import { FileUploader } from "react-drag-drop-files";
import { useSelector, useDispatch } from 'react-redux'
import { CloudUploadOutlined } from '@ant-design/icons';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';
import { useEffect } from 'react';
import { Upload } from 'antd';
import {
  setFile, getFilename, getStyle, getBizID, getObjective, getFileAlertShow, getFileAlertMessage, getFileAlertColor, setFileAlert
} from '../../libs/todoSlice'
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const validator = {
    "corporation_id": "เลขสมาชิก\n(*จำเป็นกรณีใช้งาน)",
    "title_th": "คำนำหน้าชื่อไทย",
    "name_th": "ชื่อไทย",
    "surname_th": "นามสกุลไทย",
    "title_eng": "คำนำหน้าชื่ออังกฤษ",
    "name_eng": "ชื่ออังกฤษ",
    "surname_eng": "นามสกุลอังกฤษ",
    "tel": "เบอร์โทรศัพท์ (ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค) \n(*จำเป็นกรณีใช้งาน)",
    "id_card_type": "ประเภทบัตร\n(*จำเป็นกรณีใช้งาน)",
    "cid": "เลขบัตรประชาชน\n(ไม่ต้องมีขีดกลาง (-) หรือเว้นวรรค)\n(*จำเป็นกรณีใช้งาน)",
    "address_detail": "ที่อยู่",
    "sub_district_th": "ตำบล",
    "district_th": "อำเภอ",
    "province_th": "จังหวัด",
    "zipcode": "รหัสไปรษณีย์",
    "email": "อีเมล\n(*จำเป็นกรณีใช้งาน)",
    "birth_date": "วันเกิด (ค.ศ.) (ปปปป-ดด-วว) (ถ้ามี)",
    "department": "แผนก",
    "position": "ตำแหน่ง",
    // "position_list": "แผนก/ตำแหน่ง",
}
export default function ExcelImportPreRegisterCorporationV2() {
  const dispatch = useDispatch()
  const fileNameStore = useSelector(getFilename)
  const style = useSelector(getStyle)
  const navigate = useNavigate()
  const params = useParams()

  const showAlert = useSelector(getFileAlertShow)
  const alertMessage = useSelector(getFileAlertMessage)
  const alertColor = useSelector(getFileAlertColor)
  const { Dragger } = Upload;
  useEffect(() => {
    if (showAlert) {
      setTimeout(() => {
        dispatch(setFileAlert({
          file_alert_show: false,
          file_alert_color: '',
          file_alert_message: '',
        }))
      }, 3000)
    }
  }, [showAlert]);
  const readFile = (info) => {
    return new Promise((resolve, reject) => {
      const xlsx = require('xlsx')
      if (info) {
        const reader = new FileReader();
        reader.readAsArrayBuffer(info);
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = xlsx.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = xlsx.utils.sheet_to_json(worksheet);
          reader.json = json;
          resolve({ json: json, info: info })
        };
      } else {
        resolve({ json: [], info: info })
      }
    })
  }
  const onChange = async (e) => {
    const extension = e.name.split('.')?.[1]
    if (extension !== 'xlsx' && extension !== 'xls') {
      dispatch(setFileAlert({
        file_alert_show: true,
        file_alert_color: 'error',
        file_alert_message: 'ไฟล์ไม่ถูกต้อง',
      }))

      dispatch(setFile({
        file: [],
        filename: '',
        file_id: ''
      }))
    } else {
      const { json, info } = await readFile(e)
      setStore(json, info)
    }
  }
  const objective = useSelector(getObjective)
  const checkCase = (json) => {
    const header = json[0]
    let valid = true
    for (const key in header) {
      if (Object.hasOwnProperty.call(header, key)) {
        if (!validator[key]) {
          valid = false
        }
      }
    }
    return valid
  }
  const business_id = useSelector(getBizID)
  const setStore = (json, info) => {
    const checked_json = json.filter((_, i) => i >= 1)
   
    if (json[1] === undefined || json[1] === null) {
      dispatch(setFileAlert({
        file_alert_show: true,
        file_alert_color: 'error',
        file_alert_message: 'ไฟล์ไม่ถูกต้อง',
      }))

      dispatch(setFile({
        file: [],
        filename: '',
        file_id: ''
      }))
    } else {
      if (json.length >= 10002) {
        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'error',
          file_alert_message: 'อัปโหลดครั้งละไม่เกิน 10,000 ข้อมูล',
        }))
        dispatch(setFile({
          file: [],
          filename: '',
          file_id: ''
        }))
      } else if (checkCase(json)) {
        const normalizedRows = checked_json.map((row) => {
          const { position_list, ...rest } = row
          return rest
        })

        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'success',
          file_alert_message: 'สำเร็จ',
        }))
        // console.log('checked_json :>> ', checked_json);
        dispatch(setFile({
          file: normalizedRows,
          filename: info.name,
        }))
        let formData = new FormData()
        formData.append('business_id', business_id)
        formData.append('excel', info)
        axios({
          method: 'POST',
          url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
          data: formData,
        }).then(({ data, status }) => {
          dispatch(setFile({
            file: normalizedRows,
            filename: info.name,
            file_id: data.data._id
          }))
        }, ({ response }) => {
          const { status } = response
          if (status === 401) {
            navigate(`/${params.prefix}`)
          }
        })
      } else {
        // message.error('ไฟล์ไม่ถูกต้อง')
        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'error',
          file_alert_message: 'ไฟล์ไม่ถูกต้อง',
        }))
        dispatch(setFile({
          file: [],
          filename: '',
          file_id: ''
        }))
      }
    }
  }

  const downloadForm = () => {
    window.open('/files/templates/corporation-pre-register-v2.xlsx', '_blank');
  }

  return (
    <>
      <span>แบบฟอร์มเพิ่มรายชื่อ :
        <button
          onClick={downloadForm}
          style={{
            border: 'none',
            background: 'none'
          }}>
          {objective.map(o => { if (o === 'เลขที่หนังสือสัญญา') { return 'contract' } else { return o } }).join('-').toLowerCase().replaceAll(' ', '-')}.xlsx &nbsp;
          <Tooltip title={<span style={{ fontSize: '14px' }} >ดาวน์โหลดแบบฟอร์ม</span>} placement="right" >
            <DownloadIcon style={{ color: 'black' }} />
          </Tooltip>
        </button>
      </span>
      <br />
      <Dragger
        style={{
          display: 'none'
        }}
        accept={['.xlsx', '.xls', '.csv'].join(',')}
        beforeUpload={() => false}
        maxCount={1}
      >
        <p className="ant-upload-drag-icon">
          <CloudUploadOutlined />
        </p>
        <p className="ant-upload-text">ลากและวางเอกสารที่นี่</p>
        <p className="ant-upload-hint">
          หรือเลือกไฟล์ เฉพาะไฟล์ .xls และ .xlsx เท่านั้น
        </p>
      </Dragger>

      <FileUploader
        handleChange={onChange}
        style={{
          width: '100%',
        }}
        name="file"
        types={['xlsx', 'xls', 'csv']}
        children={<>
          <Dragger
            onClick={() => false}
            openFileDialogOnClick={false}
          >
            <p className="ant-upload-drag-icon">
              <CloudUploadOutlined style={{ color: style.primary_color ?? '#053075', }} />
            </p>
            <p className="ant-upload-text">ลากและวางเอกสารที่นี่</p>
            <p className="ant-upload-hint">
              หรือเลือกไฟล์ เฉพาะไฟล์ .xls และ .xlsx เท่านั้น
            </p>
          </Dragger>

        </>
        }
      />
      <span
        style={{
          color: 'red',
          fontSize: '14px'
        }}
      >
        *กรุณาอัปโหลดครั้งละไม่เกิน 10,000 รายชื่อ
      </span><br />
      {fileNameStore ? <><strong>Filename:</strong> {fileNameStore}</> : ''}
      {showAlert &&
        <Alert
          onClose={() => {
            dispatch(setFileAlert({
              file_alert_show: false,
              file_alert_color: '',
              file_alert_message: '',
            }))
          }}
          severity={alertColor}
        >
          {alertMessage}
        </Alert>
      }
    </>
  )
}